import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchInstallationsStatusResponse } from "./FetchInstallationsStatusResponse";
import { GlobalStatusEnum } from "@/model/data/status/GlobalStatusEnum";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TagValues } from "@/model/data/Tag";
import { MaintenanceStatusEnum } from "@/model/data/status/MaintenanceStatusEnum";
import { ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";

const ENDPOINT = "/device_status";

export class FetchInstallationsStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetDevicesStatusReqData;

    constructor(payload: GetDevicesStatusReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationsStatusResponse> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsStatusResponse(res);
    }
}

export class GetDevicesStatusReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    globalStatusFilter: GlobalStatusEnum[] = [];
    connectivityStatusFilter: ConnectivityStatusEnum[] = [];
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
    maintenanceStatusList: MaintenanceStatusEnum[] = [];
}
